/**
 * 라우팅 경로 상수 (라우트 구조 변경 시 이 파일만 수정)
 */
export const ROUTES = {
  HOME: (lang: string) => `/${lang}`,
  LOGIN: (lang: string) => `/${lang}/login`,
  CART: (lang: string) => `/${lang}/cart`,
  CHECKOUT: (lang: string) => `/${lang}/checkout`,
  /** 바로 구매하기: 해당 상품만 결제, 장바구니는 변경하지 않음 */
  CHECKOUT_SINGLE: (lang: string, promptId: string) =>
    `/${lang}/checkout?single=${encodeURIComponent(promptId)}`,
  CHECKOUT_SUCCESS: (lang: string) => `/${lang}/checkout/success`,
  CHECKOUT_FAIL: (lang: string) => `/${lang}/checkout/fail`,
  PROFILE: (lang: string) => `/${lang}/profile`,
  MY_PAGE: (lang: string) => `/${lang}/my-page`,
  PROMPT_DETAIL: (lang: string, id: string) => `/${lang}/prompt/${id}`,
  ADMIN_PROMPTS: (lang: string) => `/${lang}/admin/prompts`,
} as const
